import { ElementType, ReactNode, memo } from 'react'
import { TitleContainer, TitleSection, TitleContent, TitleText, ParentTitle, ActionsSection } from './PageTitle.styles'

interface PageTitleProps {
  title: string
  subtitle?: JSX.Element | string
  icon: ElementType
  backToName?: string
  onBackClick?: () => void
  actions?: ReactNode
}

export const PageTitle = memo(Component)

function Component({ title, subtitle, icon: Icon, backToName, onBackClick, actions }: PageTitleProps) {
  function renderSubtitle(): JSX.Element | null {
    if (!subtitle) return null
    if (typeof subtitle === 'string') {
      return <span>{subtitle}</span>
    }
    return subtitle
  }

  return (
    <TitleContainer>
      <TitleSection>
        <Icon size={45} />
        <TitleContent>
          <TitleText>
            <h1>{title}</h1>
            {backToName && <ParentTitle onClick={onBackClick}>/{backToName}</ParentTitle>}
          </TitleText>
          {renderSubtitle()}
        </TitleContent>
      </TitleSection>
      {actions && <ActionsSection>{actions}</ActionsSection>}
    </TitleContainer>
  )
}
